<!-- <app-layout> -->

<app-back-header
  [headerText]="'Torna alla lista Clienti'"
  (backAction)="onCancel()"
  class="sticky-top"
>
</app-back-header>

<!-- *ngIf="!isLoading"> -->

<h3>Modifica cliente:</h3>
<!-- <mat-card-subtitle>ID: {{companyId}}</mat-card-subtitle> -->

<form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
  <mat-card class="mb-3 mt-3 mb-md-2 col-md-12 d-flex flex-column custom-card">
    <mat-card-content>
      <h5 class="mb-3">Cliente:</h5>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Nome cliente</mat-label>
          <input matInput formControlName="company_name" required />
        <mat-error *ngIf="companyForm.get('company_name')?.invalid">
          <span *ngIf="companyForm.get('company_name')?.errors?.['required']">
            Il nome è obbligatorio
          </span>
          <span *ngIf="companyForm.get('company_name')?.errors?.['pattern']">
            Solo lettere (a-z, A-Z), numeri, spazi e punti sono ammessi
          </span>
        </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let type of typeOptions" [value]="type.code">
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Partita IVA</mat-label>
          <input 
            matInput 
            formControlName="iva_number"
            maxlength="11" />
          <mat-error *ngIf="companyForm.get('iva_number')?.invalid">
            <span *ngIf="companyForm.get('iva_number')?.errors?.['pattern']">
              La Partita Iva deve essere composta esattamente da 11 cifre
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Codice fiscale</mat-label>
          <input 
            matInput 
            formControlName="c_f"
            maxlength="16" />
          <mat-error *ngIf="companyForm.get('c_f')?.invalid">
            <span *ngIf="companyForm.get('c_f')?.errors?.['pattern']">
              Il Codice Fiscale deve essere composto esattamente da 11 o 16 caratteri alfanumerici
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Codice SDI</mat-label>
          <input 
            matInput 
            formControlName="addressee_code"
            minlength="6"
            maxlength="7"
            />
            <mat-error *ngIf="companyForm.get('addressee_code')?.invalid">
              <span *ngIf="companyForm.get('addressee_code')?.errors?.['pattern']">
                Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
              </span>
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Codice interno (opzionale)</mat-label>
          <input matInput formControlName="internal_code" />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card">
    <mat-card-content>
      <h5 class="mb-3">Dati anagrafici:</h5>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Indirizzo</mat-label>
          <input matInput formControlName="address" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Città</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Comune</mat-label>
          <input matInput formControlName="comune" />
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>CAP</mat-label>
          <input 
            matInput 
            formControlName="cap"
            maxlength="5" />
          <mat-error *ngIf="companyForm.get('c_f')?.invalid">
            <span *ngIf="companyForm.get('c_f')?.errors?.['pattern']">
              Il CAP deve essere composto da 5 cifre
            </span>
          </mat-error>
        </mat-form-field>

      </div>

      <div class="row">

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Provincia (sigla)</mat-label>
          <input 
            matInput 
            formControlName="province"
            name="province"
            required
            minlength="2"
            maxlength="2"
            (blur)="validateProvince(companyForm.get('province')?.value)"
            />
          <mat-error *ngIf="companyForm.get('province')?.invalid">
            <span *ngIf="companyForm.get('province')?.errors?.['pattern']">
              La provincia deve essere di esattamente 2 lettere maiuscole
            </span>
          </mat-error>
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Nazione</mat-label>
          <input matInput formControlName="country" />
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Nazione</mat-label>
          <mat-select formControlName="country">
            <mat-option *ngFor="let country of countryOptions" [value]="country.code">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Telefono</mat-label>
          <input matInput formControlName="telephone" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Cellulare</mat-label>
          <input matInput formControlName="cellphone" />
        </mat-form-field>
      </div>

      <div class="row">

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email_address" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Pec</mat-label>
          <input matInput formControlName="pec" />
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Note</mat-label>
          <input matInput formControlName="notes" />
        </mat-form-field> -->
      </div>

      <div class="row">
        <p> Note:</p>
        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Note</mat-label>
          <textarea 
            matInput
            formControlName="notes"
            >
          </textarea>
        </mat-form-field>
      </div>

      <div class="mb-2 d-flex flex-column align-self-end">
        <div class="mt-2 mb-2 d-flex align-self-end">
          <!-- <button class="m-1" mat-button type="button" (click)="onCancel()">Indietro</button> -->
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!companyForm.valid"
            (click)="onSubmit()"
          >
            <mat-icon>save</mat-icon>
            Salva modifiche
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>

<div class="pt-3 mb-3"></div>

<!-- <div *ngIf="isLoading" class="loading-spinner">
  Loading company data...
</div> -->
<!-- </app-layout> -->
